export const isPriceRule = rule => /price/gmi.test(rule);
export const isPriceAsendingRule = rule => isPriceRule(rule) && /low.*high/gmi.test(rule);
export const isPriceDescendingRule = rule => isPriceRule(rule) && /high.*low/gmi.test(rule);

const getMinPriceValue = (priceObj) => {
  let priceObject = priceObj;

  if (priceObject.min) {
    priceObject = priceObj.min;
  }

  return priceObject.sales.value;
};

export const sortByPriceAscending = productIds => (
  [...productIds].sort((first, second) => {
    const firstPrice = first.details.rebatePrice || first.details.price;
    const secondPrice = second.details.rebatePrice || second.details.price;

    return getMinPriceValue(firstPrice) < getMinPriceValue(secondPrice) ? -1 : 1;
  })
);

export const sortByPriceDescending = productIds => (
  [...productIds].sort((first, second) => {
    const firstPrice = first.details.rebatePrice || first.details.price;
    const secondPrice = second.details.rebatePrice || second.details.price;

    return getMinPriceValue(firstPrice) > getMinPriceValue(secondPrice) ? -1 : 1;
  })
);
